import loadable from '@loadable/component';
import React from 'react';

import Spin from '../../spin/spin';

export const InfoPastesLoadable = loadable(
    () => import(/* webpackChunkName: "coding-problem-info-pastes" */ './coding-problem__info-pastes'),
    {
        fallback: <Spin center delay />,
    }
);
